import { useFeatureGate } from '@ctct/awesome-feature-flags';
import { envs } from '@ctct/infrastructure-layer';

export const useXeroPromotionGate = () => {
  if (envs.isSecure()) {
    // In secure , we don't have access to statsig, so we return a value based on the URL parameter.
    const isXeroPromotionGateViaURLParam =
      new URLSearchParams(window.location.search).get('aff-xero-promotion') === 'true';

    const isMoretonBayBIllingPage = window.location.pathname.includes('/moreton-bay');

    return {
      data: isXeroPromotionGateViaURLParam || isMoretonBayBIllingPage,
      isLoading: false,
      isError: false,
      error: null,
    } as ReturnType<typeof useFeatureGate>;
  }

  // hooks list will be stable per env, so we can safely disable the hooks rule
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useFeatureGate({
    name: 'enable_xero_promotion',
    defaultValue: false,
  });
};
